/**
 * Article Sticky Scroll - Single page scroll with transform-based column movement
 */
(function () {
  'use strict';

  if (window.innerWidth < 1025) return;

  const heroContainer = document.querySelector('.article-template__hero-container');
  const textWrapper = document.querySelector('.itg-article-text-wrapper');
  const desktopMain = document.querySelector('.itg--article-desk-main');

  if (!heroContainer || !textWrapper || !desktopMain) return;

  let heroInner = heroContainer.querySelector('.hero-inner-wrapper');
  let textInner = textWrapper.querySelector('.text-inner-wrapper');

  if (!heroInner) {
    heroInner = document.createElement('div');
    heroInner.className = 'hero-inner-wrapper';
    while (heroContainer.firstChild) {
      heroInner.appendChild(heroContainer.firstChild);
    }
    heroContainer.appendChild(heroInner);
  }

  if (!textInner) {
    textInner = document.createElement('div');
    textInner.className = 'text-inner-wrapper';
    while (textWrapper.firstChild) {
      textInner.appendChild(textWrapper.firstChild);
    }
    textWrapper.appendChild(textInner);
  }

  let heroMaxScroll = 0;
  let textMaxScroll = 0;
  let isUpdating = false;
  let listenersReady = false;
  let metricsRaf = 0;

  function updateMetrics() {
    const headerHeight = 4.05 * 16;
    const viewportHeight = window.innerHeight;
    const columnHeight = viewportHeight - headerHeight;

    const heroTransform = heroInner.style.transform;
    const textTransform = textInner.style.transform;
    heroInner.style.transform = '';
    textInner.style.transform = '';

    void heroInner.offsetHeight;
    void textInner.offsetHeight;

    heroInner.style.paddingBottom = '0';
    heroInner.style.marginBottom = '0';

    void heroInner.offsetHeight;

    const heroContentHeight = heroInner.scrollHeight;
    const textContentHeight = textInner.scrollHeight;

    heroInner.style.transform = heroTransform;
    textInner.style.transform = textTransform;

    heroMaxScroll = Math.max(0, heroContentHeight - columnHeight - 25);
    textMaxScroll = Math.max(0, textContentHeight - columnHeight);

    const tallestScroll = Math.max(heroMaxScroll, textMaxScroll);
    const containerScrollHeight = columnHeight + tallestScroll;
    const nextHeight = containerScrollHeight + 'px';

    /* Only write height when it actually changes — avoids extra layout jump */
    if (desktopMain.style.height !== nextHeight) {
      desktopMain.style.height = nextHeight;
    }
  }

  function scheduleMetrics() {
    if (metricsRaf) cancelAnimationFrame(metricsRaf);
    metricsRaf = requestAnimationFrame(function () {
      metricsRaf = 0;
      updateMetrics();
      updateScroll();
    });
  }

  function updateScroll() {
    if (isUpdating) return;
    isUpdating = true;

    requestAnimationFrame(function () {
      const rect = desktopMain.getBoundingClientRect();
      const headerHeight = 4.05 * 16;
      const viewportHeight = window.innerHeight;
      const columnHeight = viewportHeight - headerHeight;

      const containerTop = rect.top;
      const pageScrollY = window.pageYOffset;

      let scrolledPastTop = 0;
      if (pageScrollY > 0 && containerTop <= headerHeight) {
        scrolledPastTop = Math.max(0, headerHeight - containerTop);
      }

      const maxScrollDistance = Math.max(heroMaxScroll, textMaxScroll);

      let scrollProgress = 0;
      if (maxScrollDistance > 0 && scrolledPastTop > 0) {
        scrollProgress = Math.min(1, Math.max(0, scrolledPastTop / maxScrollDistance));
      }

      const expectedHeight = columnHeight + maxScrollDistance;
      if (Math.abs(desktopMain.offsetHeight - expectedHeight) > 1) {
        desktopMain.style.height = expectedHeight + 'px';
      }

      if (heroMaxScroll > 0) {
        heroInner.style.transform = 'translateY(' + -scrollProgress * heroMaxScroll + 'px)';
      } else {
        heroInner.style.transform = '';
      }

      if (textMaxScroll > 0) {
        textInner.style.transform = 'translateY(' + -scrollProgress * textMaxScroll + 'px)';
      } else {
        textInner.style.transform = '';
      }

      isUpdating = false;
    });
  }

  function initializeListeners() {
    if (listenersReady) {
      scheduleMetrics();
      return;
    }
    listenersReady = true;

    updateMetrics();
    updateScroll();

    window.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        scheduleMetrics();
      },
      { passive: true }
    );
  }

  function initScroll() {
    /* First paint metrics immediately so column height isn’t empty */
    initializeListeners();

    const images = heroContainer.querySelectorAll('img');
    if (!images.length) return;

    let pending = 0;
    images.forEach(function (img) {
      if (img.complete) return;
      pending += 1;
      var done = function () {
        pending -= 1;
        scheduleMetrics();
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });

    /* Single short fallback if some images hang — not a second full re-init loop */
    if (pending > 0) {
      setTimeout(scheduleMetrics, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
  } else {
    initScroll();
  }
})();

/**
 * Blog Video Placeholder Handler
 * Hides placeholder image when video plays
 */
(function () {
  'use strict';

  function initVideoPlaceholders() {
    const videoContainers = document.querySelectorAll('.article-template .video');

    videoContainers.forEach(function (container) {
      const video = container.querySelector('video');
      const placeholderImg = container.querySelector('img');
      const playButton = container.querySelector('span');

      if (!video || !placeholderImg) return;

      video.addEventListener('play', function () {
        container.classList.add('video-playing');
        if (playButton) {
          playButton.style.display = 'none';
        }
      });

      video.addEventListener('pause', function () {
        if (!video.ended) {
          container.classList.remove('video-playing');
          if (playButton) {
            playButton.style.display = 'flex';
          }
        }
      });

      video.addEventListener('ended', function () {
        container.classList.add('video-playing');
        if (playButton) {
          playButton.style.display = 'none';
        }
      });

      if (playButton) {
        playButton.addEventListener('click', function (e) {
          e.preventDefault();
          video.play();
        });
      }

      placeholderImg.addEventListener('click', function () {
        video.play();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoPlaceholders);
  } else {
    initVideoPlaceholders();
  }
})();
